import { UploadFileOutlined } from "@mui/icons-material";
import { Button, FormHelperText, styled } from "@mui/material";
import { getCsvContent } from "../lib/format";
import { downloadCsv } from "../lib/helper";
import { useState } from "react";
import LoadingButton from "./LoadingButton";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function UploadCSVButton<T>(props: {
  label?: string;
  helperText?: string;
  onChange: (data: T[]) => void;
  keys: (keyof T)[];
  sample?: string;
  downloadLabel?: string;
  onDownload?: () => Promise<void>;
}) {
  const { onChange, keys, sample, label, downloadLabel, onDownload, helperText } = props;
  const [downloading, setDownloading] = useState(false);

  const onUpload = async (e: any) => {
    try {
      const _members = await getCsvContent<T>(e.target.files[0], keys);
      if (_members.length > 0) {
        onChange(_members);
      }
    } catch (error: any) {
      window.webApp.showMessage(
        "error",
        `Error happened: ${error?.message || error}`,
      );
    }
    e.target.value = "";
  };

  const onDownloadSample = async () => {
    if (onDownload) {
      setDownloading(true);
      await onDownload().finally(() => setDownloading(false));
    } else if (sample) {
      downloadCsv("sample", sample);
    } else {
      window.webApp.showMessage("error", "No sample data provided");
    }
  };

  return (
    <>
      <Button
        variant="contained"
        component="label"
        className="initial-text width-100p"
        startIcon={<UploadFileOutlined />}
      >
        {label || "Import by csv"}
        <VisuallyHiddenInput
          type="file"
          accept=".csv, text/csv"
          onChange={onUpload}
        />
      </Button>
      {helperText && <FormHelperText sx={{ whiteSpace: "pre-line" }}>{helperText}</FormHelperText>}
      <LoadingButton
        loading={downloading}
        color="primary"
        variant="text"
        className="margin-t-normal"
        sx={{ textTransform: 'none' }}
        onClick={onDownloadSample}
      >
        {downloadLabel ?? "Download sample csv file"}
      </LoadingButton>
    </>
  );
}
